import { createContext, useContext, useState, useCallback } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Mocked in-memory auth — no backend, no persistence.
  const login = useCallback(async ({ email }) => {
    await new Promise((r) => setTimeout(r, 1000));
    const name = email ? email.split("@")[0].replace(/[._-]/g, " ") : "Developer";
    const u = { email, name: name.replace(/\b\w/g, (c) => c.toUpperCase()), org: "Sandbox Org" };
    setUser(u);
    return u;
  }, []);

  const signup = useCallback(async ({ fullName, email, org, market }) => {
    await new Promise((r) => setTimeout(r, 1200));
    const u = { email, name: fullName || "Developer", org: org || "Sandbox Org", market };
    setUser(u);
    return u;
  }, []);

  const logout = useCallback(() => setUser(null), []);

  return (
    <AuthContext.Provider value={{ user, login, signup, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
